export default __webpack_public_path__ + "static/media/gs8-planning.7af0f80d.png";